import type { FC } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import s from './ReportsDataTotalRowMobile.scss';

interface Props {
  data: {
    label: string;
    value: string;
    className?: string;
  }[];
}
const ReportsDataTotalRowMobile: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className={s['root']}>
      <div className={s['heading']}>
        {t('studio.reports.section.common.table.footer.total')}
      </div>
      <div className={s['data']}>
        {data.map(({ label, value, className }, index) => (
          <div className={c(s['col'], className)} key={index}>
            <div className={s['value']}>
              {label.toLowerCase() === 'price' ? '---' : value}
            </div>
            <div className={s['label']}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
ReportsDataTotalRowMobile.displayName = 'ReportsDataTotalRowMobile';

export default ReportsDataTotalRowMobile;
